export default __webpack_public_path__ + "static/media/removerequest.25e9d854.svg";